import { useReducer } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { connect } from 'formik';
import objectPath from 'object-path';

function reducer(type) {
  if (type === 'password') {
    return 'text';
  }
  return 'password';
}

function PasswordField({
  formik = undefined,
  name,
  title,
  placeholder = '',
  showValid = undefined,
  plaintext = undefined,
  readOnly = false,
  autoComplete = undefined,
  required = false,
  'data-cy': dataCy,
  ...props
}) {
  const errors = objectPath.get(formik.errors, name);
  const touched = objectPath.get(formik.touched, name);
  const value = objectPath.get(formik.values, name);

  // Visibility state
  const [type, toggleType] = useReducer(reducer, 'password');

  return (
    <>
      <Form.Label htmlFor={name}>
        {title}
        {required ? '*' : null}
      </Form.Label>
      <InputGroup>
        <Form.Control
          name={name}
          id={name}
          placeholder={placeholder}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={value}
          isValid={!errors && touched && showValid}
          isInvalid={errors && touched}
          plaintext={!!plaintext}
          readOnly={!!readOnly}
          type={type}
          autoComplete={autoComplete}
          style={{ borderRight: 'none' }}
          data-cy={dataCy}
          {...props}
        />
        <InputGroup.Text
          className="bg-white "
          style={{
            borderWidth: 1,
            color: 'rgb(73, 80, 87)',
            borderColor:
              errors && touched ? 'rgb(220, 53, 69)' : 'rgb(206, 212, 218)',
            borderLeft: 'none',
            padding: '0 10px',
          }}
        >
          <Button
            // variant=""
            style={{
              background: 'none',
              color: 'rgb(73, 80, 87)',
              borderWidth: 0,
            }}
            onClick={() => toggleType()}
          >
            <div style={{ height: '50%', fontSize: '0.8em', width: '32px' }}>
              &#128065;
            </div>
            <div
              style={{ height: '50%', fontSize: '0.65em', marginTop: '-4px' }}
            >
              {type === 'password' ? 'SHOW' : 'HIDE'}
            </div>
          </Button>
        </InputGroup.Text>
      </InputGroup>
      {errors && touched && (
        <div
          className="invalid-feedback"
          style={{ display: 'block' }}
          {...(dataCy ? { 'data-cy': `${dataCy}-invalid-feedback` } : {})}
        >
          {errors}
        </div>
      )}
    </>
  );
}

export default connect(PasswordField);
